export const isRootSupportTicket = (ticket) => !ticket?.supportTicketID;

/** Count of root tickets for the notification badge (excludes reply records). */
export const getRootTicketCount = (tickets) =>
  (tickets || []).filter(isRootSupportTicket).length;

export const formatRelativeTimestamp = (timestamp) => {
  if (!timestamp) return "";

  const now = new Date();
  const ticketDate = new Date(timestamp);
  const diffMs = now - ticketDate;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffDays > 1) return `${diffDays} Days ago`;
  if (diffDays === 1) return "Yesterday";
  if (diffHours > 0) return `${diffHours} Hours ago`;
  if (diffMins > 0) return `${diffMins} Mins Ago`;
  return "Just now";
};

export const formatSupportDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const getMessageTimestamp = (message) => {
  const value = message?.createdAt || message?.updatedAt;
  return value ? new Date(value).getTime() : 0;
};

export const sortSupportMessagesChronologically = (messages = []) =>
  [...messages].sort(
    (a, b) => getMessageTimestamp(a) - getMessageTimestamp(b)
  );
